export default __webpack_public_path__ + "static/media/user-minus.00b06302.svg";